// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","542":"component---src-pages-goal-strapi-goal-document-id-js"}[chunkId] + "-" + {"125":"109de59b61a3f71bf544","293":"86e32a293850a7883995","542":"83d4e529ad10ec8f3cc2"}[chunkId] + ".js";
};